export default [
  {
    position: "absolute",
    top: 9.5,
    left: 5.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "feedback.persona1.ttTextOne",
    hover: false,
    id: "OB_Feedback_Navigation_Homepage",
    index: 0
  },
  {
    position: "absolute",
    top: 6.8,
    left: 24.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "feedback.persona1.ttTextTwo",
    hover: false,
    id: "OB_Feedback_Navigation_PersonalDetails",
    index: 1
  },
  {
    position: "absolute",
    top: 6.8,
    left: 60.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 4,
    tooltipText: "feedback.persona1.ttTextThree",
    hover: false,
    id: "OB_Feedback_Navigation_Policies",
    index: 2
  },
  {
    position: "absolute",
    top: 1,
    left: 87.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 8,
    tooltipText: "feedback.persona1.ttTextFour",
    hover: false,
    tooltipClass: "left",
    id: "OB_Feedback_Navigation_Actions",
    index: 3
  },
  {
    position: "absolute",
    top: 79.6,
    left: 65,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "feedback.persona1.ttTextFive",
    hover: false,
    tooltipClass: "left",
    id: "OB_Feedback_Navigation_OnboardingSurvey",
    index: 4
  },
];
